import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultComplexFontSetting,
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "showUnit",
    desc: '显示单位',
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "unitText",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex',
      textAlign: "center",
      fontColor: {
        "data": {
            "stops": [
                [
                    "rgba(138,139,153,1)",
                    0
                ],
                [
                    "rgba(0,0,0,1)",
                    1
                ]
            ],
            "angle": 0
        },
        "type": "color",
        "color": "rgba(138,139,153,1)",
        "label": "颜色"
      }
    },
    extraConfig: {
      showFontTypeSetting: false,
      showTextAlignSetting: false,
      hideHighLevelSetting: true,
      showMoreBtn: false,
      hideLineHeightSetting: true,
      showLetterSpacingSetting: false
    }
  },
  {
    name: 'unitPosition',
    desc: '位置',
    type: "sliderSet",
    defaultValue: "bottom",
    extraConfig: {
      options: [
        {
          value: "top",
          title: "上",
        },
        {
          value: "bottom",
          title: "下",
        },
        {
          value: "left",
          title: "左",
        },
        {
          value: "right",
          title: "右",
        },
      ],
    },
  },
  {
    name: "unitMargin",
    desc: "间距",
    type: "numberSet",
    defaultValue: 6,
    unit: "px",
    extraConfig: {
      suffix: "px",
    }
  },
  {
    name: "unitOffset",
    desc: "偏移",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      suffix: "px",
      sliderMin: -100,
      sliderMax: 100,
    }
  },
  {
    name: "unitOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    },
    extraConfig: {
      suffix: "%",
    }
  },
  {
    name: 'yearAlias',
    desc: '年显示为',
    type: 'inputSet',
    defaultValue: '年',
    extraConfig: {
      showTitle: true,
      titleWidth: 60
    }
  },
  {
    name: 'monthAlias',
    desc: '月显示为',
    type: 'inputSet',
    defaultValue: '月',
    extraConfig: {
      showTitle: true,
      titleWidth: 60
    }
  },
  {
    name: 'dayAlias',
    desc: '天显示为',
    type: 'inputSet',
    defaultValue: '天',
    extraConfig: {
      showTitle: true,
      titleWidth: 60
    }
  },{
    name: 'hourAlias',
    desc: '时显示为',
    type: 'inputSet',
    defaultValue: '时',
    extraConfig: {
      showTitle: true,
      titleWidth: 60
    }
  }
  ,{
    name: 'minuteAlias',
    desc: '分显示为',
    type: 'inputSet',
    defaultValue: '分',
    extraConfig: {
      showTitle: true,
      titleWidth: 60
    }
  },
  {
    name: 'secondAlias',
    desc: '秒显示为',
    type: 'inputSet',
    defaultValue: '秒',
    extraConfig: {
      showTitle: true,
      titleWidth: 60
    }
  }
]

export const menuSetting = [
  "showUnit",
  {
    type: "collection",
    enable(config) {
      return config.showUnit
    },
    settings: [
      {
        type: "collapse",
        title: "排列",
        settings: ["unitPosition", "unitMargin", "unitOffset"]
      },
      {
        type: "collapse",
        title: "文字",
        settings: ["unitText"]
      },
      {
        type: "collapse",
        title: "单位格式",
        initStatus: 'closed',
        settings: [
          "yearAlias",
          "monthAlias",
          "dayAlias",
          "hourAlias",
          "minuteAlias",
          "secondAlias",
        ]
      },
      {
        type: "collapse",
        title: "更多",
        initStatus: 'closed',
        settings: ["unitOpacity"]
      }
    ]
  },
]